import { action, makeAutoObservable, observable } from 'mobx'
// Request
import { BookRequest } from '../requests/BookRequest'

class BookStore {
  /** Book Group **/
  bookGroupList = []

  constructor() {
    makeAutoObservable(this)
  }

  getBookGroup = type => {
    return new Promise((resolve, reject) => {
      BookRequest.getBookGroup(type)
        .then(response => {
          this.bookGroupList = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  clearBookGroupList = () => {
    this.bookGroupList.length = 0
  }

  /** Book **/
  bookListOfGroup = []

  getBookByBookGroupId = bookGroupId => {
    return new Promise((resolve, reject) => {
      BookRequest.getBookByBookGroupId(bookGroupId)
        .then(response => {
          this.bookListOfGroup = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  clearBookListOfGroup = () => {
    this.bookListOfGroup.length = 0
  }

  clearStore = () => {
    this.bookGroupList.length = 0
    this.bookListOfGroup.length = 0
  }
}

export default new BookStore()
